"use client"

export const dynamic = 'force-dynamic'
export const runtime = 'nodejs'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Search, ArrowRight, FileX, Home, ArrowLeft } from "lucide-react"
import Link from "next/link"
import { Navigation } from "@/components/navigation"
import { Footer } from "@/components/footer"

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <Navigation />
      
      <div className="container mx-auto px-4 py-20">
        <div className="flex items-center justify-center min-h-[calc(100vh-16rem)]">
          <Card className="w-full max-w-2xl text-center">
            <CardHeader className="pb-6">
              <div className="flex justify-center mb-6">
                <div className="relative">
                  <div className="w-24 h-24 bg-orange-50 rounded-full flex items-center justify-center">
                    <FileX className="h-12 w-12 text-orange-500" />
                  </div>
                  <div className="absolute -top-2 -right-2 bg-red-500 text-white text-sm font-bold px-2 py-1 rounded-full min-w-[3rem]">
                    404
                  </div>
                </div>
              </div>
              <CardTitle className="text-3xl md:text-4xl font-bold mb-4">
                Page Not Found
              </CardTitle>
              <CardDescription className="text-lg text-muted-foreground max-w-md mx-auto">
                The page you're looking for doesn't exist or has been moved to a different location.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  variant="outline" 
                  size="lg"
                  onClick={() => window.history.back()}
                  className="flex items-center gap-2"
                >
                  <ArrowLeft className="h-4 w-4" />
                  Go Back
                </Button>
                <Link href="/" className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 text-base h-12 px-8 gap-2">
                  <Home className="h-4 w-4" />
                  Back to Home
                </Link>
              </div>
              
              <div className="border-t pt-6">
                <div className="space-y-4">
                  <div className="text-sm text-muted-foreground">
                    <p className="font-medium mb-2">Here are some helpful links:</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-left">
                      <Link href="/docs" className="flex items-center gap-2 text-blue-600 hover:underline">
                        <ArrowRight className="h-3 w-3" />
                        API Documentation
                      </Link>
                      <Link href="/dashboard" className="flex items-center gap-2 text-blue-600 hover:underline">
                        <ArrowRight className="h-3 w-3" />
                        Dashboard
                      </Link>
                      <Link href="/pricing" className="flex items-center gap-2 text-blue-600 hover:underline">
                        <ArrowRight className="h-3 w-3" />
                        Pricing Plans
                      </Link>
                      <Link href="/contact" className="flex items-center gap-2 text-blue-600 hover:underline">
                        <ArrowRight className="h-3 w-3" />
                        Get Support
                      </Link>
                    </div>
                  </div>
                  
                  <Link href="/docs" className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full sm:w-auto gap-2">
                    <Search className="h-4 w-4" />
                    Browse Documentation
                  </Link>
                </div>
              </div>
              
              <div className="text-sm text-muted-foreground pt-4">
                <p>Need help? <Link href="/contact" className="text-blue-600 hover:underline">Contact our support team</Link></p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      
      <Footer />
    </div>
  )
} 